import _ from 'underscore';

export default (hotels) => _.flatten(_.map(hotels
        .pluck('hotelOffers'), (hotelOffers) => hotelOffers.models));
